/* CALMEA product page behaviour: quantity, sticky add-to-cart, gallery slider. */
(function () {
  'use strict';

  function initQuantity() {
    var form = document.getElementById('CalmeaBuyForm');
    if (!form) return;
    var input = form.querySelector('#CalmeaQty');
    if (!input) return;
    Array.prototype.forEach.call(form.querySelectorAll('[data-cal-qty]'), function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-cal-qty'), 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-cal-sticky]');
    if (!bar) return;
    var sync = function () {
      bar.classList.toggle('is-visible', window.scrollY > 640);
    };
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function initGallery() {
    var gal = document.querySelector('[data-cal-gal]');
    if (!gal) return;
    var track = gal.querySelector('[data-cal-gal-track]');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-cal-gal-slide]'));
    if (!track || slides.length < 2) return;

    // Progressive enhancement. Without JS the track is still a plain
    // horizontally scrollable, snapping strip that works by swipe.
    gal.classList.add('is-enhanced');

    var dots = Array.prototype.slice.call(gal.querySelectorAll('[data-cal-gal-dot]'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-cal-gal-thumb]'));
    var counter = gal.querySelector('[data-cal-gal-counter]');
    var prev = gal.querySelector('[data-cal-gal-prev]');
    var next = gal.querySelector('[data-cal-gal-next]');
    var index = -1;
    var raf = 0;

    function paint(i) {
      if (i === index) return;
      index = i;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' of ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      gal.setAttribute('data-cal-gal-index', String(i));
    }

    function goTo(i) {
      i = Math.min(slides.length - 1, Math.max(0, i));
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      paint(i);
    }

    // Derive the active slide from scroll position. This covers touch swipe,
    // trackpad, momentum and programmatic scrolls in one place. An
    // IntersectionObserver rooted on the track proved unreliable here.
    function syncFromScroll() {
      var w = slides[0].getBoundingClientRect().width || 1;
      var i = Math.round(track.scrollLeft / w);
      paint(Math.min(slides.length - 1, Math.max(0, i)));
    }

    track.addEventListener('scroll', function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.getAttribute('data-cal-gal-dot'), 10));
      });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.getAttribute('data-cal-gal-thumb'), 10));
      });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
    });

    window.addEventListener('resize', function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    paint(0);
  }

  function init() {
    initQuantity();
    initSticky();
    initGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();